export const prettifyPlanName = (name: string) => name.replace(/\d+$/, '');
